import { render, staticRenderFns } from "./EditCompany.vue?vue&type=template&id=10f0ba82&scoped=true&"
import script from "./EditCompany.vue?vue&type=script&lang=js&"
export * from "./EditCompany.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/util.css?vue&type=style&index=0&id=10f0ba82&scoped=true&lang=css&"
import style1 from "./EditCompany.vue?vue&type=style&index=1&id=10f0ba82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f0ba82",
  null
  
)

export default component.exports